import { defineRecipe } from '@chakra-ui/react';

const Separator = defineRecipe({
  base: {
    opacity: 1,
    backgroundColor: 'podcastShade200',
  },
  variants: {
    visual: {
      none: {},
      signUp: {
        height: '1px',
        marginTop: '7px',
        opacity: 1,
        backgroundColor: 'podcastShade100',
        marginBottom: '10px',
        width: '100%',
      },
      alituWavesHeader: {
        borderColor: 'podcastPurple800',
        height: '18px',
        width: '2px',
        opacity: 0.2,
        backgroundColor: 'podcastPurple800',
      },
    },
  },
  defaultVariants: {
    visual: 'none',
  },
});

export default Separator;
